import React from 'react';

import './displaypercent.css';

const calcPercentClass = (percent=0)=>{
  percent=+percent;
  return percent > 69 ? 'percent-high' : percent < 40 ? 'percent-low' : 'percent-medium'
};


const DisplayPercent=({percent,className})=>{
  if(!percent) percent=0;
  let ratingClass = 'display-percent ' + calcPercentClass(percent);
  if(className) {
    ratingClass+=' '+className;
  }

  return (
    <span className={ratingClass}>{percent}%</span>
  )

}

export default DisplayPercent;